import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';

const ProtectedRoute = ({ element, allowedRoles, ...rest }) => {
    const { currentUser, setNotification } = useContext(AuthContext);

    if (!currentUser) {
        setNotification({
            message: 'Je moet ingelogd zijn om deze pagina te bekijken.',
            style: { backgroundColor: 'red', color: 'white', width:'100%' }
        }); // Stel melding in
        return <Navigate to="/login" />;
    }

    if (!allowedRoles.includes(currentUser.role)) {
        setNotification({
            message: 'Je hebt geen toegang tot deze pagina.',
            style: { backgroundColor: 'red', color: 'white',  width:'50%' }
        }); // Stel melding in
        return <Navigate to="/" />;
    }

    return element;
};

export default ProtectedRoute;
